module.exports = __webpack_public_path__ + "assets/fonts/MiloOffc-Light.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/milo-light/MiloOffc-Light.woff
// module id = 516
// module chunks = 0